import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { site } from "../data/content";

const Footer = () => (
  <footer className="border-t border-ink bg-ink text-paper">
    <div className="mx-auto max-w-7xl px-6 py-20 md:py-28">
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/50">
        Next brief
      </p>
      <Link
        to="/contact"
        data-testid="footer-contact-cta"
        className="group mt-6 block"
      >
        <span className="font-display text-4xl font-bold leading-[1.02] tracking-tight transition-colors duration-300 group-hover:text-blue md:text-7xl">
          LET'S TAKE THE NEXT
          <br />
          PROBLEM OFF THE SLIDE.
        </span>
        <span className="mt-8 inline-flex items-center gap-2 border border-paper px-5 py-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 group-hover:border-blue group-hover:bg-blue group-hover:text-paper">
          Start a conversation <ArrowUpRight size={14} />
        </span>
      </Link>
    </div>
    <div className="border-t border-paper/15">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-8 md:flex-row md:items-center md:justify-between">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/50">
          {site.name} — {site.role}
        </p>
        <div className="flex items-center gap-6">
          <a
            href={`mailto:${site.email}`}
            data-testid="footer-email-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/70 transition-colors duration-300 hover:text-blue"
          >
            Email
          </a>
          <a
            href={site.phoneLink}
            data-testid="footer-phone-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/70 transition-colors duration-300 hover:text-blue"
          >
            {site.phone}
          </a>
          <a
            href={site.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/70 transition-colors duration-300 hover:text-blue"
          >
            LinkedIn
          </a>
        </div>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-paper/50">
          © 2026 · {site.location}
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
